import React from "react";
import causeEducation from "../../assets/images/causes/cause-education.jpg";
import causeRights from "../../assets/images/causes/cause-rights.jpg";
import causeCulture from "../../assets/images/causes/cause-culture.jpg";
import causeHunger from "../../assets/images/causes/cause-hunger.jpg";

const Causes = () => (
  <div className="section-home our-causes animate-onscroll fadeIn">
    <div className="container">
      <h2 className="title-style-1">
        Our Causes <span className="title-under"></span>
      </h2>

      <div className="row">
        <div className="col-md-3 col-sm-6">
          <div className="cause">
            <img src={causeHunger} alt="" className="cause-img" />

            <div className="progress cause-progress">
              <div
                className="progress-bar"
                role="progressbar"
                aria-valuenow="30"
                aria-valuemin="0"
                aria-valuemax="100"
                style={{ width: 30 }}
              >
                10$ / 500$
              </div>
            </div>

            <h4 className="cause-title">
              <div>HUNGER AND POVERTY </div>
            </h4>
            <div className="cause-details">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut at
              eros rutrum turpis viverra elementum semper quis ex. Donec lorem
              nulla, aliquam quis neque vel, maximus lacinia urna.
            </div>

            <div className="btn-holder text-center">
              <div
                className="btn btn-primary"
                data-toggle="modal"
                data-target="#donateModal"
              >
                {" "}
                DONATE NOW
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-3 col-sm-6">
          <div className="cause">
            <img src={causeEducation} alt="" className="cause-img" />

            <div className="progress cause-progress">
              <div
                className="progress-bar"
                role="progressbar"
                aria-valuenow="60"
                aria-valuemin="0"
                aria-valuemax="100"
                style={{ width: 60 }}
              >
                400$ / 700$
              </div>
            </div>

            <h4 className="cause-title">
              <div>EDUCATION AND TRAINING</div>
            </h4>
            <div className="cause-details">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut at
              eros rutrum turpis viverra elementum semper quis ex. Donec lorem
              nulla, aliquam quis neque vel, maximus lacinia urna.
            </div>

            <div className="btn-holder text-center">
              <div
                className="btn btn-primary"
                data-toggle="modal"
                data-target="#donateModal"
              >
                {" "}
                DONATE NOW
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-3 col-sm-6">
          <div className="cause">
            <img src={causeRights} alt="" className="cause-img" />

            <div className="progress cause-progress">
              <div
                className="progress-bar"
                role="progressbar"
                aria-valuenow="40"
                aria-valuemin="0"
                aria-valuemax="100"
                style={{ width: 40 }}
              >
                400$ / 1000$
              </div>
            </div>

            <h4 className="cause-title">
              <div>HUMAN RIGHTS</div>
            </h4>
            <div className="cause-details">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut at
              eros rutrum turpis viverra elementum semper quis ex. Donec lorem
              nulla, aliquam quis neque vel, maximus lacinia urna.
            </div>

            <div className="btn-holder text-center">
              <div
                className="btn btn-primary"
                data-toggle="modal"
                data-target="#donateModal"
              >
                {" "}
                DONATE NOW
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-3 col-sm-6">
          <div className="cause">
            <img src={causeCulture} alt="" className="cause-img" />

            <div className="progress cause-progress">
              <div
                className="progress-bar"
                role="progressbar"
                aria-valuenow="60"
                aria-valuemin="0"
                aria-valuemax="100"
                style={{ width: 60 }}
              >
                400$ / 700$
              </div>
            </div>

            <h4 className="cause-title">
              <div>ARTS AND CULTURE </div>
            </h4>
            <div className="cause-details">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut at
              eros rutrum turpis viverra elementum semper quis ex. Donec lorem
              nulla, aliquam quis neque vel, maximus lacinia urna.
            </div>

            <div className="btn-holder text-center">
              <div
                className="btn btn-primary"
                data-toggle="modal"
                data-target="#donateModal"
              >
                {" "}
                DONATE NOW
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Causes;
